export const constants = {
  title: process.env.REACT_APP_PAGE_TITLE,
  description: process.env.REACT_APP_PAGE_DESCRIPTION,
  btnText: process.env.REACT_APP_PAGE_LINK_TEXT,
  url: process.env.REACT_APP_REDIRECT_URL,
  dac_title: process.env.REACT_APP_DAC_PAGE_TITLE,
  dac_description: process.env.REACT_APP_DAC_PAGE_DESCRIPTION,
  dac_btnText: process.env.REACT_APP_DAC_PAGE_LINK_TEXT,
  dac_url: process.env.REACT_APP_DAC_REDIRECT_URL,
};
